import { faRuler } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ControlButton } from "../ui/MapControls";

interface MeasureControlProps {
    measuring: boolean;
    toggleMeasure: () => void;
}

export const MeasureControlBase = (props: MeasureControlProps) => (
    <div className="flex flex-col gap-3">
        <ControlButton
            className="w-8 rounded"
            selected={props.measuring}
            onClick={(e) => {
                e.stopPropagation();
                props.toggleMeasure();
            }}
        >
            <FontAwesomeIcon icon={faRuler} className="h-4" />
        </ControlButton>
    </div>
);
